//replaces wwotable.html
import type { FC } from "react";

import { MiniFlexTable } from "app/components/React/Table/FlexTable/Mini/MiniFlexTable";

import type { IDashboardWidgetInterface } from "../utils/DashboardWidgetsInterfaces-v2";

import type { ITableWidget } from "./TableTemplate-v2";

export const WWOTopRefCategoriesTemplateV2: FC<IDashboardWidgetInterface<ITableWidget>> = (props) => {
    const { widget } = props;

    return widget.data.Records.length ? (
        <MiniFlexTable
            tableData={widget.data}
            tableColumns={widget.metadata.columns}
            tableOptions={widget.metadata.options}
        />
    ) : null;
};
